module.exports = __webpack_public_path__ + "img/29_68.d022ded6.png";